import api from '@appbase/api';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
// components
import { mapGetters, mapMutations } from 'vuex';
import * as accountTypes from '@account/store/types';
import * as types from '@appbase/store/types';

@Component({
    name: 'GraphList',
    components: { },
    methods: {
        ...mapMutations({
            selectedAttachment: types.SELECT_ATTACHMENT
        })
    },
    computed: {
        ...mapGetters({
            user: accountTypes.USER,
        }),
    },
})
export default class GraphList extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    // @Prop({ type: String }) o365GuId!: string;
    @Prop({ type: String }) selectedId!: string;
    @Prop({ type: Object }) selectItem!: any;
    @Prop({ type: Array }) highlightId!: any[];
    @Prop({ type: String }) type!: string;
    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    selectedAttachment!: (item:any) => void;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    item: basemail.graphOption = {
        o365GuId: '',
        teamsId: '',
        channelId: '',
        driveId:'',
        itemId: '',
        groupId: '',
        order: 0
    }
    user!: User;
    //items: any = [];
    icon: string = ''
    expanded: boolean = false
    list: any = []
    //highlightId: string = '';
    //highlightId: any = [];
    isLoading: boolean = false;
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Watch('selectItem')
    onChangedSelectItem(){
        // console.log("test2test2test2test2test2", this.selectItem);
        // console.log("test3test3test3test3test3", this.item);
        switch(this.type){
            case 'Teams':
            //     if(this.selectItem){
            //         api.attachment.getchannelsList(this.selectItem).then((res)=>{
            //            this.list = JSON.parse(res);
            //        })
            //    }
            //console.log("this.selectItem.order", this.selectItem.order);
                switch(this.selectItem.order){
                    case 1 : 
                        this.item.order = 1
                        api.attachment.getTeamsLists(this.item).then((res:any)=>{
                            //console.log("this.itemthis.itemthis.itemthis.item11", this.item);
                            this.list = JSON.parse(res.replaceAll('displayName','name'))
                            this.list.forEach((i:any) =>{
                                this.$set(i, 'order', this.item.order)
                            })
                            this.$emit("isloading", false)
                        })
                        break;
                    case 2 : 
                        this.item.order = 2
                        this.item.teamsId = this.selectItem.id
                        api.attachment.getTeamsChannelsList(this.item).then((res)=>{
                            //this.list = JSON.parse(res.replaceAll('displayName','name'));
                            this.list = res
                            this.list.forEach((i:any) =>{
                                this.$set(i, 'order', this.item.order)
                            })
                            this.$emit("isloading", false)
                        })
                        break;
                    case 3 : 
                        this.item.order = 3
                        this.item.teamsId = this.selectItem.teamsId
                        this.item.channelId = this.selectItem.id
                        api.attachment.getChannelsDetail(this.item).then((res)=>{
                            var plist = JSON.parse(res);
                            if(plist != ''){
                                this.item.driveId = plist.parentReference.driveId
                                this.item.itemId = plist.id
                                api.attachment.getoneDriveItemsChildren(this.item).then((reschild)=>{
                                    this.list = JSON.parse(reschild);
                                    this.list.forEach((i:any) =>{
                                        this.$set(i, 'order', this.item.order)
                                    })
                                    this.$emit("isloading", false)
                                    //console.log("this.listlist2222", this.list);
                                })
                            }

                            // this.list = JSON.parse(res.replaceAll('displayName','name'));
                            // this.list.forEach((i:any) =>{
                            //     this.$set(i, 'order', this.item.order)
                            // })
                            //this.$emit("isloading", false)
                            //console.log("listlistlist33333", this.list);
                        })
                        break;
                    default : 
                        this.item.driveId = this.selectItem.parentReference.driveId
                        this.item.itemId = this.selectItem.id
                        api.attachment.getoneDriveItemsChildren(this.item).then((res)=>{
                            this.list = JSON.parse(res);
                            this.$emit("isloading", false)
                        })
                        break;
                }
            break;
            case 'OneDrive':
                if(this.selectItem.id == ''){
                    api.attachment.getoneDriveList(this.item).then((res)=>{
                        this.list = JSON.parse(res)
                        this.$emit("isloading", false)
                    })
                }else{
                    this.item.driveId = this.selectItem.id;
                    api.attachment.getoneDriveListChildren(this.item).then((res)=>{
                        this.list = JSON.parse(res);
                        this.$emit("isloading", false)
                    })
                }
            break;
        }
    }

    @Watch('selectedId')
    onChangedSelectedId(){
    //    this.item.o365GuId = this.user.o365Guid;
        // if(this.selectedId === 'default'){
        //     api.attachment.getoneDriveList(this.item).then((res)=>{
        //         this.list = JSON.parse(res)
        //     })
        // }else{
        //     console.log("test1");
        //     this.item.driveId = this.selectedId;
        //     api.attachment.getoneDriveListChildren(this.item).then((res)=>{
        //         this.list = JSON.parse(res);
        //     })
        // }

        //console.log("this.item.orderthis.item.order", this.item);

        switch(this.type){
            case 'Teams':
                this.item.teamsId = this.selectedId;
                switch(this.item.order){
                    case 1 : 
                        this.item.order = 1
                        api.attachment.getTeamsLists(this.item).then((res:any)=>{
                            //console.log("this.itemthis.itemthis.itemthis.item11", this.item);
                            this.list = JSON.parse(res.replaceAll('displayName','name'))
                        })
                        break;
                    case 2 : 
                        this.item.order = 2
                        api.attachment.getTeamsChannelsList(this.item).then((res)=>{
                            //this.list = JSON.parse(res.replaceAll('displayName','name'));
                            this.list = res
                            this.list.forEach((i:any) =>{
                                this.$set(i, 'order', this.item.order)
                            })
                        })
                        break;
                    case 3 : 
                        this.item.order = 3
                        api.attachment.getChannelsDetail(this.item).then((res)=>{

                            if(res != ''){
                                api.attachment.getoneDriveItemsChildren(this.item).then((res)=>{
                                    this.list = JSON.parse(res.replaceAll('displayName','name'));
                                    this.list.forEach((i:any) =>{
                                        this.$set(i, 'order', this.item.order)
                                    })
                                    //console.log("this.listlist2222", this.list);
                                })
                            }

                            // this.list = JSON.parse(res.replaceAll('displayName','name'));
                            // this.list.forEach((i:any) =>{
                            //     this.$set(i, 'order', this.item.order)
                            // })
                            //console.log("this.listlist3333", this.list);
                        })
                        break;
                    default : 
                        api.attachment.getoneDriveItemsChildren(this.item).then((res)=>{
                            this.list = JSON.parse(res);
                        })
                        break;
                }
            break;
            case 'OneDrive':
                if(this.selectedId === ''){
                    api.attachment.getoneDriveList(this.item).then((res)=>{
                        this.list = JSON.parse(res)
                    })
                }else{
                    this.item.driveId = this.selectedId;
                    api.attachment.getoneDriveListChildren(this.item).then((res)=>{
                        this.list = JSON.parse(res);
                    })
                }
            break;
        }
    }
  
   //
   // ────────────────────────────────────────────────────── I ──────────
   //   :::::: M E T H O D S : :  :   :    :     :        :          :
   // ────────────────────────────────────────────────────────────────
   //

    // select(item:any){
    //     let idx = this.highlightId.indexOf(item.id);
    //     if (idx !== -1) {
    //         this.highlightId.splice(idx, 1);
    //     } else {
    //         this.highlightId.push(item.id);
    //     }

    //     console.log("itemitemitemitem", item);
    //     this.$emit('selectItem', item);
    //     if(item.folder){
    //             this.high$emitlightId = [];
    //             this.('navigation',{id:item.id, name:item.name})
    //             this.item.driveId = item.id;
    //             this.item.itemId = item.id;
    //             api.attachment.getoneDriveListChildren(this.item).then((res)=>{
    //                 this.list = JSON.parse(res);
    //             })
    //     }
    //     if(item.File){
    //         this.selectedAttachment(item);
    //     }
    // }


    imgUrl(item:any){
        if(this.type == 'Teams'){
            //Teams인 경우
            switch(this.item.order){
                case 1 : 
                    return "/cm/gres/faux/images/teams.svg"  //최초 Teams 불러온경우 Teams 아이콘 표시
                case 2 : 
                    return "/cm/gres/faux/images/Extension/ico_folder_close.gif"
            }
        }
    
        if(item.folder?item.folder:item.Folder){
           return "/cm/gres/faux/images/Extension/ico_folder_close.gif";
        }else if(item.file?item.file:item.File){
            //let extension = item.name?item.name.split('.')[1]:item.Name.split('.')[1].toLowerCase();
            let extension = item.name.substring(item.name.lastIndexOf(".")).split('.')[1].toLowerCase();
            switch(extension){
                case 'ppt': 
                case 'pptx': 
                    return "/cm/gres/faux/images/Extension/ico-ppt.png"
                case 'xls':
                case 'xlsx':
                    return "/cm/gres/faux/images/Extension/ico-xls.png"       
                case 'doc':
                case 'docx':
                    return "/cm/gres/faux/images/Extension/ico-doc.png"
                case 'dng':
                    return "/cm/gres/faux/images/Extension/ico-dng.png"
                case 'dwg':
                    return "/cm/gres/faux/images/Extension/ico-dwg.png"
                case 'hwp':
                    return "/cm/gres/faux/images/Extension/ico-hwp.png"
                case 'mpp':
                    return "/cm/gres/faux/images/Extension/ico-mpp.png"
                case 'pdf':
                    return "/cm/gres/faux/images/Extension/ico-pdf.png"
                case 'psd':
                    return "/cm/gres/faux/images/Extension/ico-psd.png"
                case 'pub':
                    return "/cm/gres/faux/images/Extension/ico-pub.png"
                case 'txt':
                    return "/cm/gres/faux/images/Extension/ico-txt.png"
                case 'vdw':
                    return "/cm/gres/faux/images/Extension/ico-vdw.png"
                case 'video':
                    return "/cm/gres/faux/images/Extension/ico-video.png"
                case 'xps':
                    return "/cm/gres/faux/images/Extension/ico-xps.png" 
                case 'zip':
                    return "/cm/gres/faux/images/Extension/ico-zip.png"
                case 'jpg':
                    return "/cm/gres/faux/images/Extension/ico-img.png"
                case 'bmp':
                    return "/cm/gres/faux/images/Extension/ico-img.png"
                case 'png':
                    return "/cm/gres/faux/images/Extension/ico-img.png"
                case 'tif':
                    return "/cm/gres/faux/images/Extension/ico-img.png"
                case 'gif':
                    return "/cm/gres/faux/images/Extension/ico-img.png"
                default:
                    return "/cm/gres/faux/images/Extension/ico-nomal.png"
            }
        }
      }

   created(){
    // this.$parent.parentMethod(true)
        //this.onChangedSelectedId();
    //    this.item.o365GuId = this.user.o365Guid;
    //    api.attachment.getoneDriveList(this.item).then((res)=>{
    //        this.list = JSON.parse(res)
    //     //    this.list.forEach((item:any)=>{
    //     //        if(item.folder){
    //     //         this.imgUrl = "/cm/gres/faux/images/Extension/ico_folder_close.gif";
    //     //        }else if(item.file){
    //     //            if(item.name.split('.')[1] === 'pptx'){
    //     //             this.imgUrl="/cm/gres/faux/images/Extension/ico-ppt.png"
    //     //            } 
    //     //       }
    //     //    })
    //     //    if(this.list && this.list.folder){
    //     //        this.imgUrl = "/cm/gres/faux/images/Extension/ico_folder_close.gif";
    //     //    }else if(this.list.{
    //     //    }
    //    })
    // console.log("this.typethis.typethis.type", this.type);
    // this.$emit('isLoading', true);
        this.item.o365GuId = this.user.o365Guid;
        switch(this.type){
            case 'Teams':
                this.item.order = 1
                api.attachment.getTeamsLists(this.item).then((res:any)=>{
                    this.list = JSON.parse(res.replaceAll('displayName','name'))
                    this.list.forEach((i:any) =>{
                        this.$set(i, 'order', this.item.order)
                    })
                    this.$emit("isloading", false)
                })
            break;
            case 'OneDrive':
                api.attachment.getoneDriveList(this.item).then((res:any)=>{
                    this.list = JSON.parse(res)
                    this.$emit("isloading", false)
                })
            break;
        }
   }
}
